
import React, { useEffect, useState, useContext,useRef } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import {timesheetreportService} from '../services/timesheetreportsService';
import {timesheetService} from '../services/timesheetService';
import {formatterhelper} from '../helpers/dateformatter';
import { Paginator } from 'primereact/paginator';
import {loader} from '../compnents/loadermd';
import {Nodatacomp,Nodataprimecomp} from '../compnents/nodatacomp';
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { Dialog } from 'primereact/dialog';
import { timesheetuserService } from '../services/timesheetUserservice';
import { Toast } from 'primereact/toast';
import { Message } from 'primereact/message';
import { InputText } from 'primereact/inputtext';
import { FaBeer, FaCheck, FaEdit, FaLock, FaRecycle, FaSearch, FaUnlock } from "react-icons/fa";

import {dataExporthelper} from '../helpers/exporthelper';
var XLSX = require("xlsx");

const Bookkeepingbill = () => {
    
    const toast = useRef(null);
    const [formData, setFormData] = useState({
        fromdate: '',
        todate: '',
        user_id: '',
        clientid: 'ALL',
        subclient: 'ALL',
      });
    const [datacomp,setDatacomp] = useState([]); 
    const [dataavail,setDatastate] = useState(false); 
    const [cleintscomp,setClientscomp] = useState([]); 
    const [subclientscomp,setsubClientscomp] = useState([]); 
    const [empcomp,setempcomp] = useState([]); 
    const [userscomp,setuserscomp] = useState([]);
    const [userslists,setuserslists] = useState([]); 
    const [totalpages,setPages] = useState(0);
    const [filterobj,setfilterobj] = useState({});
    const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
    const [isloaded,setloading] = useState(true);
    const [isuserloaded,setuserloading] = useState(true);
    const [dialogtoggle,setdialogtoggle] = useState(false);
    
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(15);
    const [currentpage, setCurrpage] = useState(1);
    const [adjustments, setAdjustments] = useState([]);
    const [userslistcomp, setUserslistscomp] = useState([]);
    const [clientloaded, setClientloading] = useState(true);
    const [reportslists, setReportslists] = useState([]);
    // const [reportslists, setReportslists] = useState([]);
    const [valuedataarr, setvaluedataarr] = useState([]);
    const [wholevaluedataarr, setwholevaluedataarr] = useState([]);
    const [errors, setErrors] = useState({});
    const [isexporting, setExporting] = useState(true);
    const [isverified, setisVerified] = useState(true);
    const [ismultiapproved, setMultiapproved] = useState(true);
    const [calculateddata,setCalculatedata] = useState({billingminsaved:0,totalactualhours: 0});
    // const [filterobj2,setFilterobj] = useState({});
    
     
    useEffect(()=>{
        // console.log(filterobj.length);
        if((Object.keys(filterobj).length == 0) == false){
            getbkbillreports({objdata:filterobj});
        }else{
            getemplist();
            getalluserslist(); 
        }
        
    },[currentpage]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
        
        if(name == 'user_id'){
            // console.log("employee");
            // console.log(value);
            _getclientslist({setmanagerid:value});
            // _getsubclient({clientid:value}); 
        }

        if(name == 'clientid'){
            _getsubclient({clientid:value});
        }
    };

    const validateForm = () => {
        let valid = true;
        const newErrors = {};

        if (formData.fromdate == '') {
            newErrors.fromdate = 'Field is required';
            valid = false;
          }

          if (formData.todate == '') {
            newErrors.todate = 'Field is required';
            valid = false;
          }  

        if (formData.user_id == '') {
          newErrors.user_id = 'Field is required';
          valid = false;
        }

        if (formData.clientid == '') {
            newErrors.clientid = 'Field is required';
            valid = false;
          }

        setErrors(newErrors);

       return valid; 
    } 

    const handleSubmit = (e) => {
        e.preventDefault();

        if(!validateForm()){
             return;
        }
        let fromdate = formatterhelper.dateformatter({date:formData.fromdate});
        let todate = formatterhelper.dateformatter({date:formData.todate});
        setloading(false);

        if(formData.clientid == 'ALL'){
            formData.subclient = 'ALL'; 
        } 
        let objdata = {
           'fromdate':fromdate,    
           'todate':todate,
           'clientid':formData.clientid,
           'user_id':formData.user_id,
           'subclient':formData.subclient     
        }; 
        setfilterobj(objdata);
        getbkbillreports({objdata:objdata,pageno:1});
   };

   const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
    let pageno = 1;
    if(event.first == 0){
     pageno = 1;    
    }else{
     pageno = ((event.first/rows) + 1);  
    }
    // console.log(pageno);
    setCurrpage(pageno);
   
   
    console.log("page chnaged");
};

   function getbkbillreports({objdata,pageno = 1}){
    setloading(false);
    timesheetreportService.bkfinalbillreport({obj:objdata,page:currentpage}).then((response)=>{
        if(response.status == 200){
            setReportslists(response.data.data.data);
            setPages(response.data.data.total);
            console.log(response.data.total_data);
            setCalculatedata(response.data.total_data);
        }else{
            setReportslists([]);  
        }
        setloading(true);
        setDatastate(true);
    }).catch((error)=>{
        console.log("error");
        console.log(error); 
        setReportslists([]);
        setloading(true);
        setDatastate(true);
    });
   }

     
    const stdminchanged = (newValue,index,valuedata) => {
        const newAdjustments = [...reportslists];

        newAdjustments[index].stdminsaved = newValue;
        let billinghrs = ((newAdjustments[index].countval * newAdjustments[index].stdminsaved)/60);

        // console.log("billing hours");
        // console.log(billinghrs);
        if(billinghrs > newAdjustments[index].billedhours){
            newAdjustments[index].stdbillingminsaved = billinghrs;         
        }else{
            newAdjustments[index].stdbillingminsaved = newAdjustments[index].billedhours;
        }
        // console.log(reportslists[index].stdminsaved);
        // console.log((reportslists[index].countval * reportslists[index].stdminsaved)/60);

        setReportslists(newAdjustments);
        // if (valuedataarr.indexOf(valuedata.timesheetid) === -1) {
        //     valuedataarr.push(valuedata.timesheetid);
        //     wholevaluedataarr.push(valuedata);
        // }

        if (valuedataarr.indexOf(valuedata.timesheetid) === -1) {
            valuedataarr.push(valuedata.timesheetid);
            // wholevaluedataarr.push(valuedata);
        }

        const index1 = wholevaluedataarr.findIndex(obj => obj.timesheetid === valuedata.timesheetid);
        if (index1 === -1) {
            wholevaluedataarr.push(valuedata);
        }else{
            // console.log(index);
            wholevaluedataarr[index1] = valuedata; 
            // wholevaluedataarr.push(valuedata);
        }
      
    };

    const billingChanged = (e,key,valuedata) =>{
        console.log("billing chnaged");
        // console.log(e.target.value);
        // reportslists[key].billedhours = e.target.value; 
        const newAdjustments = [...reportslists];
        // console.log(newAdjustments[key]);
        newAdjustments[key].stdbillingminsaved = e.target.value;
        // console.log(newAdjustments);
        setReportslists(newAdjustments);
        if (valuedataarr.indexOf(valuedata.timesheetid) === -1) {
            valuedataarr.push(valuedata.timesheetid);
            // wholevaluedataarr.push(valuedata);
        }

        const index = wholevaluedataarr.findIndex(obj => obj.timesheetid === valuedata.timesheetid);
        if (index === -1) {
            wholevaluedataarr.push(valuedata);
        }else{
            // console.log(index);
            wholevaluedataarr[index] = valuedata; 
            // wholevaluedataarr.push(valuedata);
        }
        console.log(wholevaluedataarr);
    }

    function qtlstatuschng(index,e,valuedata){
        // console.log(e.target.checked);
        const newAdjustments = [...reportslists];
        if(e.target.checked){
            // console.log(true); 
            newAdjustments[index].qtlstatus = true;     
        }else{
            // console.log(false);      
            newAdjustments[index].qtlstatus = false;
        }
        setReportslists(newAdjustments);
         if (valuedataarr.indexOf(valuedata.timesheetid) === -1) {
            valuedataarr.push(valuedata.timesheetid);
            // wholevaluedataarr.push(valuedata);
        }

        const index1 = wholevaluedataarr.findIndex(obj => obj.timesheetid === valuedata.timesheetid);
        if (index1 === -1) {
            wholevaluedataarr.push(valuedata);
        }else{
            // console.log(index);
            wholevaluedataarr[index1] = valuedata; 
            // wholevaluedataarr.push(valuedata);
        }
       
    }


    function __sendforapproval(key){
        //  console.log(key);
        key.date = key.filled_date;
         let obj = {'id':key,"type":'bk'};
         obj = JSON.stringify(obj);
         timesheetService.sendforapproval({formdata:obj}).then((response)=>{
             console.log(response);
             if(response.status == 200){
                toast.current.show({severity:'success', summary: "Send for Approval", detail:`Send for approval`, life: 3000});   
                getbkbillreports({objdata:filterobj,pageno:1});
            }else{
                toast.current.show({severity:'error', summary: "Send for Approval", detail:`Not send`, life: 3000});    
             }
         }).catch((error)=>{
            // console.log(response); 
            toast.current.show({severity:'error', summary: "Send for Approval", detail:`Error`, life: 3000}); 
         });
    }

    function displaybkreport(){
        try{
            let emparr = [];  
            reportslists.forEach((key,index)=>{
                // reportslists[index].stdbillingminsaved = key.billedhours > ((key.countval * key.stdminsaved)/60) ? key.billedhours : ((key.countval * key.stdminsaved)/60).toFixed(2);
                emparr.push((<tr>
                               <td>{key.timesheetid}</td>
                               <td>{key.userid}</td>
                               <td>{key.client}</td>
                               <td>{key.subclient}</td>
                               <td>{key.username}</td>
                               <td>{key.roles}</td>
                               <td>{key.filled_date}</td>
                               <td>{key.projectname}</td>
                               <td>{key.taskname}</td>
                               <td>{key.actual_hrs}</td>
                               <td>{key.billedmin}</td>
                               <td>{key.billedhours}</td>
                               <td>{key.countval}</td>
                               <td>{key.actualhours}</td>
                               
                               <td><input type="number" className='form-control' style={{width:'100px'}}  value={reportslists[index].stdminsaved} onChange={(e)=>stdminchanged(e.target.value,index,key)} /></td>
                               
                               <td>
                                {key.stdminsaved == '' || key.stdminsaved == null || key.stdminsaved == undefined ? 0 : (((key.countval * key.stdminsaved)/60) == null ? 0 : ((key.countval * key.stdminsaved)/60).toFixed(2)) }</td> 
                               <td>
                               <input type="number" className='form-control' style={{width:'100px'}}
                                onChange={(e) => billingChanged(e,index,key)}
                                 value={reportslists[index].stdbillingminsaved}  />
                               </td>
                               <td>{key.timesheetstatus}</td>
                               <td><input type="checkbox" checked={key.qtlstatus} onChange={(e) => qtlstatuschng(index,e,key)}/></td>
                               <td> 
                                <button className='btn btn-default' onClick={() => __sendforapproval(key)}>
                                  { (key.isapprovedfor == 'step1' || key.isapprovedfor == 'step2') ? (<FaCheck className='edit-btn-style'/>) : (<FaCheck title="Send for approval"/>)}
                                </button>
                                {key.islocked == 'yes' ? (<FaLock  className='edit-btn-style' title="Subclient is Locked not able to update the value"/>) : key.islocked == 'no' ? (<FaUnlock  className='error' title="Not Locked"/>) : (<></>)}</td>
                               <td>{key.remark}</td> 
                </tr>));
            }); 
            return emparr;
        }catch(error){
            console.log(error);    
        }
    }

    function getemplist(){
        let member = userdata.id;
        let managerid = member;
        let emparr = [];
        timesheetreportService.getemployeelist({managerid:managerid}).then((response)=>{
           console.log(response);
           response.data.data.forEach((value,index) =>{
              emparr.push((<option value={value.id}>{value.name}</option>));
           });
           setempcomp(emparr);
        }).catch((error)=>{

        });  
    }

    function _getclientslist({setmanagerid}){
        let managerid = setmanagerid;
        let emparr = [];
        setClientloading(false);
        timesheetreportService.getclientslist({managerid:managerid}).then((response)=>{
            // console.log(response.data.data);
            if(response.status == 200){
                response.data.data.forEach((value,index) =>{
                    if(value.client != ''){
                        emparr.push((<option value={value.id}>{value.client}</option>));         
                    }
                });
                setClientscomp(emparr);
                setClientloading(true);
            }else{
                setClientloading(true); 
            }
            
         }).catch((error)=>{
            setClientloading(true); 
         });    
    }

    function _getsubclient({clientid}){
        try{
            let _clientid = clientid;
            let emparr = [];
            timesheetService.getsubclientlistallspecific({clientid:_clientid}).then((response)=>{
                // console.log(response);
                response.data.data.forEach((value,index) =>{
                    emparr.push((<option value={value.id}>{value.subclient}</option>));
                });
                setsubClientscomp(emparr);
             }).catch((error)=>{
     
             });    
        }catch(error){
           console.log(error);
        }
    }


    const exportexcel = () =>{
      setExporting(false);
      let fromdate = formatterhelper.dateformatter({date:formData.fromdate});
      let todate = formatterhelper.dateformatter({date:formData.todate});
      if(formData.clientid == 'ALL'){
          formData.subclient = 'ALL'; 
      } 
      let objdata = {
         'fromdate':fromdate,    
         'todate':todate,
         'clientid':formData.clientid,
         'user_id':formData.user_id,
         'subclient':formData.subclient     
      };
     
      timesheetreportService.bkfinalbillreportexport({obj:objdata}).then((response)=>{
          if(response.status == 200){
            //   setReportslists(response.data.data);
              exportToExcel(response.data.data);
              setExporting(true);
          }else{
            //   setReportslists([]); 
            setExporting(true); 
          }
      }).catch((error)=>{
        setExporting(true);
      });
      
    }

    function exportToExcel(data) {
        dataExporthelper.exportToExcel(data,{filename:'bkfinalreports'});
    }
    const headerElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <span className="font-bold white-space-nowrap">Update Adjustment</span>
            <div className='pull-right'>
              <span>
               <Button type="button" onClick={savefinalbilldata} label="Save" className='custom-btn-style custom-button-height-style' severity="success" rounded /> 
              </span>
            </div>
        </div>
    );

    function getuserconfig({obj}){
       setdialogtoggle(true);
       getuserfinalbill({obj});
    }

    const handleAdjustmentChange = (index, newValue) => {
        const newAdjustments = [...adjustments];
        newAdjustments[index] = newValue;
        console.log(newAdjustments[index]);
        setAdjustments(newAdjustments);
    };

    function getuserfinalbill({obj}){
        try{ 
            let temcomp= [];
            let formatteddate = formatterhelper.dateformatter({date:formData.fromdate});
            
            let filterdata = {
                subclient:obj.cl_id,
                fromdate:formatteddate,
                client_id:'',
                managerid:'164'
            };
            setuserloading(false);
            
            // fromdate=2023-10&client_id=undefined&managerid=164&subclient=2213
             timesheetreportService.getuserfinalbill({obj:filterdata}).then((response)=>{
                if(response.status == 200){
                    setuserslists(response.data.data);
                    let tempadjustment = [];
                    response.data.data.forEach((value,index)=>{
                        tempadjustment.push(value.adsadjustment);
                        // adjustments[index]  = value.adsadjustment;
                    });
                    setAdjustments(tempadjustment);
                    setuserloading(true);
                }else{
                    setuserslists([]);
                    setuserloading(true);
                }
               // setuserscomp(temcomp);  
             }).catch((error)=>{
                setuserloading(true);
             });
        }catch(error){
            console.log(error);
        }
    }

    function getusercomp(){
        try{
            let temcomp= [];
            userslists.forEach((value,index)=>{
                // adjustments[index] = value.adsadjustment; 
                temcomp.push((
                   (<tr key={index}>
                    <td scope="col">{value.usr_id}</td>
                    <td scope="col">{value.u_name}</td>
                    <td scope="col">{value.client}</td>
                    <td scope="col">{value.subclient}</td>
                    <td scope="col">{value.actualhrs}</td>
                    <td scope="col">{value.billed}</td>
                    <td scope="col">
                        <input
                        type="number"
                        className='form-control'
                        value={adjustments[index]}
                        onChange={(e) => handleAdjustmentChange(index, e.target.value)}
                        />
                    </td>
                    <td scope="col">Adjustment (Difference between Final billing to Billed Hrs as per timesheet)</td>
                    </tr>)     
                ));
            }); 
            return  temcomp;
        }catch(error){
            console.log(error);
           return []; 
        }
        
    }
    function savefinalbilldata(){
        //  console.log('save final bill');
        //  console.log(tableexport('user-table-export'));
         let tableexport_ = tableexport('user-table-export');
         let obj = {
            data_detail:tableexport_,
            date:'2023-10' 
         };
         obj = JSON.stringify(obj);
         
         timesheetuserService.updatesubclientadjust({formdata:obj}).then((response)=>{
            console.log(response);
            if(response.status == 200){
                toast.current.show({severity:'success', summary: "Final bill", detail:`Bill Updated`, life: 3000});    
                setdialogtoggle(false);
            }else{
                toast.current.show({severity:'error', summary: "Final bill", detail:`Not Updated`, life: 3000});        
            }
         }).catch((error)=>{
            console.log(error);
         });
    }

    const tableexport = (id = 'user-table-export') => {
        const table = document.getElementById(id);
        const rows = table.getElementsByTagName("tr");
        const rowData = [];
        for (let i = 1; i < rows.length; i++) {
          const row = rows[i];
          const cells = row.getElementsByTagName("td");
          const rowDataItem = {};
          
          
          // Loop through each cell in the row
          for (let j = 0; j < cells.length; j++) {
            const cell = cells[j];
            const headerCell = table.rows[0].cells[j]; // Get the corresponding header cell
            const columnName = headerCell.innerText.toLowerCase().replace(/\s+/g, "");
            const input = cell.querySelector("input[type='number']");
            
            const inputtext = cell.querySelector("input[type='text']");
            const inputcheckbox = cell.querySelector("input[type='checkbox']");
            
            let cellValue = ''; 
            if (input) {
               cellValue = input.value.trim();
            }else{
               cellValue = cell.innerText.trim();
            }
            // console.log('DATA CELL VALUE');
            // console.log(columnName);  
            // console.log(cellValue);
            
            // const cellValue = cell.innerText.trim();
            // Add the data to the rowDataItem object using the column name as the key
            rowDataItem[columnName] = cellValue;
          }
      
          // Add the rowDataItem object to the rowData array
          rowData.push(rowDataItem);
        }
      
        return rowData;
    }

    function getalluserslist(){
        let  temparr = []; 
        setuserloading(false);
        timesheetuserService.getalluserslist().then((response)=>{
            // console.log('response data get users lists');
            // console.log(response.data.data);
            if(response.status == 200){
                
                response.data.data.forEach((value,index)=>{ 
                    temparr.push((<option value={value.id}>{value.name}</option>));  
                }); 
                setUserslistscomp(temparr);
                setuserloading(true);
            }else{
                setUserslistscomp([]);
                setuserloading(true); 
            }
            
         }).catch((error)=>{
            setUserslistscomp([]);
            setuserloading(true);
         });
    }

    function savebillingdata(){
        console.log("value data arr");
        // console.log(wholevaluedataarr);
        // return;
        let obhjdata = {
            'allowedtimesheets': valuedataarr,
            'bkdata':wholevaluedataarr, 
        };

        let stringjson = JSON.stringify(obhjdata);

        timesheetService.savebkdata({formdata:stringjson}).then((response)=>{
            console.log(response);
            if(response.status == 200){
                toast.current.show({severity:'success', summary: "Bookkeeping Reports", detail:`Bill Updated`, life: 3000});    
            }else{
                toast.current.show({severity:'error', summary: "Bookkeeping Reports", detail:`${response.data.data}`, life: 3000});     
            }
        }).catch((error)=>{
            console.log(error);
            toast.current.show({severity:'error', summary: "Bookkeeping Reports", detail:`Error`, life: 3000});     
        });
        // console.log("obhj data");
        // console.log(obhjdata);
        // const ws = XLSX.utils.json_to_sheet(data);
        // const wb = XLSX.utils.book_new();
        // XLSX.utils.book_append_sheet(wb, ws, 'Sheet 1');
        // XLSX.writeFile(wb, 'bookkeepingreport.xlsx');    
    }

    function searchclients(e){
        console.log(e.target.value,'serach cleint');
    }


    function multiverifybk(){
         setisVerified(false);
         timesheetService.multiverifybk(filterobj).then((response)=>{
            if(response.status == 200){
                toast.current.show({severity:'success', summary: "Bookkeeping Reports", detail:`Verified successfully`, life: 3000});
                setisVerified(true);  
                
                getbkbillreports({objdata:filterobj,pageno:1}); 
            }else{
                toast.current.show({severity:'error', summary: "Bookkeeping Reports", detail:`Not  Verified`, life: 3000});   
                setisVerified(true);  
            }
         }).catch((error)=>{
            //  console.log(error);
             toast.current.show({severity:'error', summary: "Bookkeeping Reports", detail:`Not  Verified`, life: 3000});   
             setisVerified(true);  
         });
    }

    function multisendforapproval(){
        setMultiapproved(false);
        timesheetService.multisendforapproval(filterobj).then((response)=>{
           if(response.status == 200){
               toast.current.show({severity:'success', summary: "Multi approval", detail:`Send for approval`, life: 3000});
               setMultiapproved(true);  
               getbkbillreports({objdata:filterobj,pageno:1}); 
           }else{
               toast.current.show({severity:'error', summary: "Multi approval", detail:`No send`, life: 3000});   
               setMultiapproved(true);  
           }
        }).catch((error)=>{
           //  console.log(error);
            toast.current.show({severity:'error', summary: "Multi approval", detail:`Error`, life: 3000});   
            setMultiapproved(true);  
        });
   }

    return (
        <>
            <Toast ref={toast} />
            <div className="invisible-divider-sm"></div>
            <h6>Bookkeeping Reports</h6>
            <Dialog header={headerElement} position={"top"} visible={dialogtoggle} style={{ width: '60vw' }} onHide={() => setdialogtoggle(false)}>
               {/* <form onSubmit={handleSubmit}> */}
               <div className='col-md-12'>
                 <div className='row'>
                    <div className='col-md-12'>
                        {!isuserloaded ? (loader.Loadermd()) : userslists != undefined && userslists.length <= 0 ? (<Nodatacomp/>) : ( 
                            <table class="table table-bordered" id="user-table-export">
                        <thead>
                            <tr>
                                <th scope="col">Id</th>
                                <th scope="col">Username</th>
                                <th scope="col">Client</th>
                                <th scope="col">Sub Client</th>
                                <th scope="col">Actualhrs in (Min)</th>
                                <th scope="col">Billmin in (Min)</th>
                                <th scope="col">Final billing in (Min)</th>
                                <th scope="col">Adjustment (Difference between Final billing to Billed Hrs as per timesheet)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {getusercomp()}
                        </tbody>
                    </table>)}
                    
                     </div>
                  </div> 
                  <br/>  
                 
               </div>
              {/* </form> */}
             </Dialog>
            <div className='card card-custom-style card-style-padding'>
              <form onSubmit={handleSubmit}>
                <div className='row'>
                    <div className="col-md-2">
                        <label className='pull-left'>From date</label>
                        <Calendar  value={formData.fromdate} name="fromdate" onChange={handleChange} className='calender-custom-style custom-width-style' />
                        {errors.fromdate && <span className='error'>{errors.fromdate}</span>}
                    </div>

                    <div className="col-md-2">
                        <label className='pull-left'>To date</label>
                        <Calendar  value={formData.todate} name="todate" onChange={handleChange} className='calender-custom-style custom-width-style' />
                        {errors.todate && <span className='error'>{errors.todate}</span>}
                    </div>
                    
                    <div className="col-md-2">
                        <label className='pull-left'>Select User {!isuserloaded  ? loader.Smallloader() : (<></>)}</label>
                        <select className='form-control'  name="user_id" value={formData.user_id} onChange={handleChange}>
                            <option value='' >Select User</option>
                            <option value='all'>ALL</option>
                            {userslistcomp}
                        </select>
                        {errors.user_id && <span className='error'>{errors.user_id}</span>}
                    </div>
                    <div className="col-md-2">
                        <label className='pull-left'>Select Client {!clientloaded  ? loader.Smallloader() : (<></>)}  </label>
                        <select className='form-control' name='clientid' value={formData.clientid} onChange={handleChange}>
                            <option value='ALL'>ALL</option>
                            {cleintscomp}
                        </select>
                        {errors.clientid && <span className='error'>{errors.clientid}</span>}
                    </div>
                    {
                        formData.clientid != 'ALL' ? (<div className="col-md-2">
                        <label className='pull-left'>Select SubClient</label>
                        <select className='form-control' name='subclient' value={formData.subclient} onChange={handleChange}>
                            <option value='ALL'>ALL</option>
                            {subclientscomp}
                        </select>
                    </div>) : (<></>)
                    }
                    
                   
                    <div className="col-md-2">
                        <div className='button-wrapper-style'>
                            <Button type='submit' stype="button" label="Show" severity="success" rounded className='custom-btn-style' />
                            &nbsp;&nbsp;&nbsp; 

                            <Button type='button' label="Export" severity="info" rounded className='custom-btn-style' onClick={()=>exportexcel()} >
                              {!isexporting ? (loader.Smallloader()) : (<></>)}
                            </Button>
                        </div>
                        
                    </div>
                   
                </div>
                </form>
            </div>
            <div className="invisible-divider-sm"></div>
            <div className='card card-custom-style card-style-padding'>
              <div className='row'>
                    <div className='col-md-12'> 
                     <div style={{display:'flex'}}>
                     <Button type="button" onClick={() => savebillingdata()}  label="Save" severity="success" rounded className='custom-btn-style pull-left' />
                     &nbsp;&nbsp;&nbsp;&nbsp;
                       {reportslists.length > 0 ? (<Button type='button' onClick={() => multiverifybk()}>Multi Verify {!isverified ? (loader.Smallloader()) : (<></>)} </Button>) : (<></>)}
                       &nbsp;&nbsp;&nbsp;&nbsp;
                       {reportslists.length > 0 ? (<Button type='button' className='btn btn-warning' onClick={() => multisendforapproval()}>Multi Send for approval {!ismultiapproved ? (loader.Smallloader()) : (<></>)} </Button>) : (<></>)}
                     </div>
                      
                       {/* <span className="p-input-icon-left pull-left">
                        <FaSearch />
                        <InputText placeholder="Search" 
                        onKeyDown={(e)=>{searchclients(e)}}/>
                        </span> */}
                    </div>
                    <div className='pagination col-md-12'>
                        {/* <PaginationExample items={totalpages} currentPaged={currentPage} lastpage={last_page} perpage={per_page} getuserfun={getUsers}/> */}
                        {isloaded && dataavail ? (<Paginator first={first} rows={rows} totalRecords={totalpages} rowsPerPageOptions={[15]} onPageChange={onPageChange} />) : (<></>)}
                        
                    </div>
                </div>
               
                <div className='row'>
                    <div className='col-md-12'>
                    {!isloaded ? loader.Loadermd() : reportslists.length == 0 ? <Nodataprimecomp /> :  (
                            <table class="table table-bordered" id="bookkeeping-table-id">
                            <thead>
                            <tr>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col">
                                        {/* Minutes */}
                                        </th>
                                    <th scope="col">
                                        {/* Billed Minutes */}
                                        </th>
                                    <th scope="col">
                                        {/* Billed Hours */}
                                        </th>
                                    <th scope="col"></th>
                                    <th scope="col">{calculateddata.totalactualhours}</th>
                                    <th scope="col">
                                        {/* Std Min */}
                                        </th>
                                    <th scope="col">
                                        {/* Std time */}
                                        </th>
                                    <th scope="col">{calculateddata.billingminsaved}</th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                    <th scope="col"></th>
                                </tr>
                                <tr>
                                    <th scope="col">Autoall</th>
                                    <th scope="col">Userid</th>
                                    <th scope="col">Client</th>
                                    <th scope="col">SubClient</th>
                                    <th scope="col">User</th>
                                    <th scope="col">Roles</th>
                                    <th scope="col">Date</th>
                                    <th scope="col">Project	Task</th>
                                    <th scope="col">Task</th>
                                    <th scope="col">Minutes</th>
                                    <th scope="col">Billed Minutes</th>
                                    <th scope="col">Billed Hours</th>
                                    <th scope="col">Count</th>
                                    <th scope="col">Actual Hr</th>
                                    <th scope="col">Std Min</th>
                                    <th scope="col">Std time</th>
                                    <th scope="col">Billing Hr</th>
                                    <th scope="col">Status</th>
                                    <th scope="col">Verified</th>
                                    <th scope="col">Islocked</th>
                                    <th scope="col">Remark</th>
                                </tr>
                            </thead>
                            <tbody>
                                {displaybkreport()}
                            </tbody>
                        </table> 
                        )}
                    </div>
                    {/* : (<p>No data Found</p>)}  */}
                </div>
            </div>

            <div className="invisible-divider-sm"></div>
            {/* <div className="row">
                <h1>table</h1>
            </div> */}
        </>
    );
}

export default Bookkeepingbill;